import { useGetMintrudDictQuery } from '@services/mintrudDict'
import useItemsFilters from './useItemsFilters'

const useMintrudDict = () => {
  const { filters, setFilters, setPage } = useItemsFilters({}, false)

  const state = useGetMintrudDictQuery({ ...filters, pagination: false })

  return {
    ...state,
    setFilters,
    setPage,
  }
}

export default useMintrudDict
